import { render, staticRenderFns } from "./dj-container-scroll.vue?vue&type=template&id=5bb18ff1&scoped=true&"
import script from "./dj-container-scroll.vue?vue&type=script&lang=js&"
export * from "./dj-container-scroll.vue?vue&type=script&lang=js&"
import style0 from "./dj-container-scroll.vue?vue&type=style&index=0&id=5bb18ff1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb18ff1",
  null
  
)

export default component.exports